import { jsx } from "react/jsx-runtime";
import { ApexSubmit } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
const BUTTON_TYPE_MAP = {
  primary: {
    tone: "brand",
    emphasis: "filled"
  },
  secondary: {
    tone: "brand",
    emphasis: "outlined"
  },
  tertiary: {
    tone: "neutral",
    emphasis: "outlined"
  },
  caution: {
    tone: "critical",
    emphasis: "filled"
  }
};
const BlockApexSubmit = ({
  attrs
}) => {
  const {
    content,
    // v8 legacy prop - resolved to tone/emphasis below, stripped from the DOM
    buttonType = "primary",
    // WordPress editor-only attr - must not reach the DOM
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lock,
    // v10 props - win field-by-field if already stored
    tone,
    emphasis,
    ...restAttrs
  } = attrs;
  const legacyToneEmphasis = BUTTON_TYPE_MAP[buttonType] || BUTTON_TYPE_MAP.primary;
  const resolvedToneEmphasis = {
    tone: tone ?? legacyToneEmphasis.tone,
    emphasis: emphasis ?? legacyToneEmphasis.emphasis
  };
  return /* @__PURE__ */ jsx(ApexSubmit, { ...restAttrs, ...resolvedToneEmphasis, children: content });
};
BlockApexSubmit.propTypes = {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
};
export {
  BlockApexSubmit as default
};
